import React from "react";
import navarrow from "../src/assets/back_btn.png";

class OpenThirdPartyURL extends React.Component {

    constructor() {
        super();
        this.state = {
            iFrameHeight: '0px'
        }
    }

    handlebackbtn = () => {
        console.log("props data in ifsc component in handlebackbtn click",this.props) 
        this.props.history.push({pathname:'/addbankaccount/',data:{duplicatedata:this.props.location.data.duplicatedata,account_number:this.props.location.data.account_number,reaccount_number:this.props.location.data.reaccount_number,ifsc:this.props.location.data.ifsc,handleBackBtnClick:this.props.location.data.handleBackBtnClick}})    
    }

    componentDidMount() {
       console.log("props in openthirdpartyurl component",this.props)
    }
    render() {

        return (
            <div>

<nav
            className=" ph2 pv2 tr fixed top-0 left-0 right-0 shadow-4 z-999 "
            style={{ backgroundColor: "#eabf69" ,color:"#032146" }}
          >
            <div className="w-100  db center ">
              <div className="flex justify-start items-center" >
                <img fill="#ffffff"
                  className="w1"
                  src={navarrow}
                  alt="no available"
                  style={{width:"25px"}}  onClick={() => this.handlebackbtn()}/>
                <p className="f4-l f4 mv0 text-medium tc ml2">Redeem</p>
              </div>
            </div>

          </nav>
               
                {/* <div className="ph2 ph6-l f6 f4-l f5-ns tc center bg-white" style={{ height:"100%",width:"100%",paddingTop: "3rem", overflow:"hidden"}} height="100%" width="100%"> */}

                <iframe style={{ paddingTop: "3rem", marginTop: "2px", marginBottom: "2px", height: "100vh", width: "100%", overflowY: "scroll" }} height="100vh" width="100%"  title="" frameBorder="0px" overflowY="scroll" src="https://www.bankbazaar.com/ifsc-code.html" >
                </iframe>
                {/* </div> */}
            </div>

        );
    }
}

export default OpenThirdPartyURL;